import iconFactory from 'syft-acp-atoms/Icons'

export const IconX = iconFactory('x', 'Cancelled')
